/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UnproxiedMcpServerUsageBreakdownPayload,
  UnproxiedMcpServerUsageBreakdownPayload$Outbound,
  UnproxiedMcpServerUsageBreakdownPayload$outboundSchema,
} from "../components/unproxiedmcpserverusagebreakdownpayload.js";

export type GetUnproxiedMcpServerToolUsageSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetUnproxiedMcpServerToolUsageSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetUnproxiedMcpServerToolUsageSecurity = {
  option1?: GetUnproxiedMcpServerToolUsageSecurityOption1 | undefined;
  option2?: GetUnproxiedMcpServerToolUsageSecurityOption2 | undefined;
};

export type GetUnproxiedMcpServerToolUsageRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  unproxiedMcpServerUsageBreakdownPayload:
    UnproxiedMcpServerUsageBreakdownPayload;
};

/** @internal */
export type GetUnproxiedMcpServerToolUsageSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetUnproxiedMcpServerToolUsageSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerToolUsageSecurityOption1$Outbound,
    GetUnproxiedMcpServerToolUsageSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getUnproxiedMcpServerToolUsageSecurityOption1ToJSON(
  getUnproxiedMcpServerToolUsageSecurityOption1:
    GetUnproxiedMcpServerToolUsageSecurityOption1,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerToolUsageSecurityOption1$outboundSchema.parse(
      getUnproxiedMcpServerToolUsageSecurityOption1,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerToolUsageSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetUnproxiedMcpServerToolUsageSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerToolUsageSecurityOption2$Outbound,
    GetUnproxiedMcpServerToolUsageSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getUnproxiedMcpServerToolUsageSecurityOption2ToJSON(
  getUnproxiedMcpServerToolUsageSecurityOption2:
    GetUnproxiedMcpServerToolUsageSecurityOption2,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerToolUsageSecurityOption2$outboundSchema.parse(
      getUnproxiedMcpServerToolUsageSecurityOption2,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerToolUsageSecurity$Outbound = {
  Option1?: GetUnproxiedMcpServerToolUsageSecurityOption1$Outbound | undefined;
  Option2?: GetUnproxiedMcpServerToolUsageSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetUnproxiedMcpServerToolUsageSecurity$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerToolUsageSecurity$Outbound,
    GetUnproxiedMcpServerToolUsageSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        GetUnproxiedMcpServerToolUsageSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        GetUnproxiedMcpServerToolUsageSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function getUnproxiedMcpServerToolUsageSecurityToJSON(
  getUnproxiedMcpServerToolUsageSecurity:
    GetUnproxiedMcpServerToolUsageSecurity,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerToolUsageSecurity$outboundSchema.parse(
      getUnproxiedMcpServerToolUsageSecurity,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerToolUsageRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UnproxiedMcpServerUsageBreakdownPayload:
    UnproxiedMcpServerUsageBreakdownPayload$Outbound;
};

/** @internal */
export const GetUnproxiedMcpServerToolUsageRequest$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerToolUsageRequest$Outbound,
    GetUnproxiedMcpServerToolUsageRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      unproxiedMcpServerUsageBreakdownPayload:
        UnproxiedMcpServerUsageBreakdownPayload$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
        gramProject: "Gram-Project",
        unproxiedMcpServerUsageBreakdownPayload:
          "UnproxiedMcpServerUsageBreakdownPayload",
      });
    }),
  );

export function getUnproxiedMcpServerToolUsageRequestToJSON(
  getUnproxiedMcpServerToolUsageRequest: GetUnproxiedMcpServerToolUsageRequest,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerToolUsageRequest$outboundSchema.parse(
      getUnproxiedMcpServerToolUsageRequest,
    ),
  );
}
